import { type TrendEvent } from '../../api/client';
import { productDetailsStatusLabel } from '../../lib/reportFormat';
import { SellerCell } from './SellerCell';
import { TruncatedCell } from './TruncatedCell';

export function ProductDetailsCard({ event }: { event: TrendEvent }) {
  const details = event.product_details;
  const image = details?.main_image;
  const externalUrl = details?.external_url ?? event.external_url;
  const categoryPath = details?.category_path ?? event.category_path;

  return (
    <section className="grid flex-1 gap-4 md:grid-cols-[180px_1fr]">
      <div className="flex aspect-square items-center justify-center overflow-hidden rounded-md border border-border-default bg-surface-2">
        {image ? (
          <img
            src={image}
            alt={event.sku_title ?? event.sku_external_id}
            className="h-full w-full object-cover"
            loading="lazy"
          />
        ) : (
          <span className="px-4 text-center text-caption text-text-tertiary">
            Фото не получено
          </span>
        )}
      </div>
      <div className="min-w-0 space-y-3">
        <div>
          <div className="rubric">{event.event_type}</div>
          <h3 className="text-h3 font-strong text-text-primary">
            {event.sku_title ?? event.sku_external_id}
          </h3>
          <div className="mono text-caption text-text-tertiary">SKU {event.sku_external_id}</div>
        </div>
        <div className="grid gap-2 text-caption md:grid-cols-2">
          <div>
            <span className="text-text-tertiary">Бренд:</span> {event.brand ?? '—'}
          </div>
          <div className="min-w-0">
            <span className="text-text-tertiary">Продавец:</span>{' '}
            <SellerCell name={event.seller} externalId={event.seller_external_id} />
          </div>
          <div className="md:col-span-2">
            <span className="text-text-tertiary">Категория:</span>{' '}
            <TruncatedCell value={categoryPath} />
          </div>
          <div>
            <span className="text-text-tertiary">Первое появление:</span>{' '}
            {event.first_seen_date ?? '—'}
          </div>
          <div>
            <span className="text-text-tertiary">Детализация:</span>{' '}
            {productDetailsStatusLabel(details?.source)}
          </div>
        </div>
        {details?.description ? (
          <div className="h-24 min-h-24 max-h-[50vh] resize-y overflow-auto rounded-md bg-surface-2 p-3 text-caption text-text-secondary">
            {details.description}
          </div>
        ) : null}
        {details?.complectation || details?.availability ? (
          <div className="grid gap-2 text-caption md:grid-cols-2">
            {details.complectation ? (
              <div>
                <span className="text-text-tertiary">Комплектация:</span> {details.complectation}
              </div>
            ) : null}
            {details.availability ? (
              <div>
                <span className="text-text-tertiary">Наличие:</span> {details.availability}
              </div>
            ) : null}
          </div>
        ) : null}
        {externalUrl ? (
          <a
            href={externalUrl}
            target="_blank"
            rel="noreferrer"
            className="btn-primary btn-sm inline-flex"
          >
            Открыть на WB
          </a>
        ) : null}
      </div>
    </section>
  );
}
